// import * as firebase from 'firebase';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

// import axios from 'axios';

// const config = {
//     apiKey: "AIzaSyCjoChnlzEDOt2eeoXSGdZqrXdsnRrAC7Y",
//     authDomain: "mystorage-cd584.firebaseapp.com",
//     databaseURL: "https://mystorage-cd584.firebaseio.com",
//     projectId: "mystorage-cd584",
//     storageBucket: "mystorage-cd584.appspot.com",
//     messagingSenderId: "919282323349"
//   };



const  config = {
    apiKey: "AIzaSyByPyCA_FQBPRd27kOB9rBnfbQMTP0_U3o",
    authDomain: "fir-mlstiudio-91.firebaseapp.com",
    databaseURL: "https://fir-mlstiudio-91.firebaseio.com",
    projectId: "fir-mlstiudio-91",
    storageBucket: "fir-mlstiudio-91.appspot.com",
    messagingSenderId: "518571447957",
    appId: "1:518571447957:web:34ea17728d777306dfad9c",
    measurementId: "G-Y939XZGEKF"
}

const MyStore = firebase.initializeApp(config);

// firebase.initializeApp(config);

const database = firebase.database();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookProvider = new firebase.auth.FacebookAuthProvider();
const twitterProvider = new firebase.auth.TwitterAuthProvider();

// let authState = axios.get('/auth/current_user');
export {MyStore, firebase, googleAuthProvider, facebookProvider, twitterProvider, database as default };




  // export default MyStore;